<app-navbar>
    <h2>Resetare parola</h2>
</app-navbar>


<div class="login-area pt-100">
    <div class="container">
        <div class="row justify-content-center">

            <div class="col-12">
                <div class="row">
                    <div class="col-md-6 col-12 mx-auto">
                        <!--Server Response-->
                        <app-form-response [serverResponse]='serverResp' *ngIf="formHasBeenSend">
                            <div class="success-content" *ngIf="serverResp === true">
                                <p class="text-white font-weight-bold mb-0">Parola modificata!</p>
                            </div>
                            <div class="error-content" *ngIf="serverResp === false">
                                <p class="text-white font-weight-bold mb-0">{{serverErrorMessages}}</p>
                            </div>
                        </app-form-response>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-12">
                <form #resetPasswordForm="ngForm" (ngSubmit)="onSubmit(resetPasswordForm)" *ngIf="!formSuccessfulSend">
                    <div class="form-group">
                        <input type="email"
                               class="form-control"
                               placeholder="Adresa de email"
                               id="userEmail"
                               ngModel
                               name="userEmail"
                               required
                               email
                               #userEmail="ngModel"
                        >
                        <!--Error Message-->
                        <div class="help-block" *ngIf="!userEmail.valid && userEmail.touched" style="color: red;">
                            Te rog sa introduci un email valid!
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="password"
                               class="form-control"
                               placeholder="Parola noua"
                               id="userPassword"
                               ngModel
                               name="userPassword"
                               required
                               #userPassword="ngModel"
                               [pattern]="pwdPattern"
                        >
                        <span class="help-block" *ngIf="userPassword.errors?.pattern && userPassword.touched" style="color: red;">Parola trebuie sa contina cel putin 7 caractere, un numar, un caracter special, o litera mica si o litera mare. </span>

                        <!-- <span class="help-block" *ngIf="!userPassword.valid && userPassword.touched">Parola trebuie sa contina cel putin 7 caractere, un numar, o majuscula, un caracter special, o litera mica si litera mare. </span> -->
                    </div>
                    <div class="form-group">
                        <input type="email"
                               class="form-control"
                               placeholder="Cod de resetare"
                               id="userResetCode"
                               ngModel
                               name="userResetCode"
                               required
                               #userResetCode="ngModel"
                        >
                        <!--Error Message-->
                        <div class="help-block" *ngIf="!userResetCode.valid && userResetCode.touched" style="color: red;">
                            Te rog sa introduci un cod valid!
                        </div>
                    </div>

                    <div class="sub-login text-center mt-5">
                        <div class="text-center">
                            <button type="submit"
                                    class="green-button"
                                    [disabled]="!resetPasswordForm.valid">Resetare parola
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
